import { render } from "./SystemPage.vue?vue&type=template&id=d7502b44&scoped=true"
import script from "./SystemPage.vue?vue&type=script&lang=js"
export * from "./SystemPage.vue?vue&type=script&lang=js"

import "./SystemPage.vue?vue&type=style&index=0&id=d7502b44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7502b44"]])

export default __exports__